<template>
  <div class="chart">
    <div>
      <h4 v-if="$slots.title" style="marginbottom: 20px">
        <slot name="title" />
      </h4>
      <h4 v-else-if="title" style="marginbottom: 20px">
        {{ title }}
      </h4>
      <chart :option="chartOption" :style="{ height: chartHeight }" />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, watch, computed, onMounted } from 'vue';
import { Chart } from '@/components';

export default defineComponent({
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const chartOption = reactive({
      color: ['#3aa1ff', '#4aba04'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: [],
        top: 1,
      },
      grid: {
        left: '3%',
        top: 20,
        right: '4%',
        bottom: '1%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: [],
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          },
        },
      },
      series: [],
    });

    const chartHeight = computed(() => `${props.height}px`);

    const setChartOption = data => {
      const xAxis = [];
      const seriesData1 = {
        name: data.data_title_1,
        type: 'line',
        data: data.data1,
      };
      const seriesData2 = {
        name: data.data_title_2,
        type: 'line',
        data: data.data2,
      };
      const legend = [data.data_title_1, data.data_title_2];
      data.date_list.forEach(item => {
        xAxis.push(item);
      });
      chartOption.xAxis.data = xAxis;
      chartOption.series.push(seriesData1, seriesData2);
      chartOption.legend.data = legend;
    };

    watch(
      () => props.data,
      () => {
        setChartOption(props.data);
      },
    );

    onMounted(() => {
      setChartOption(props.data);
    });

    return {
      chartOption,
      chartHeight,
      setChartOption,
    };
  },
  components: {
    Chart,
  },
});
</script>

<style scoped></style>
